/**
 * cookie-panel.js
 *
 * Cookie preferences panel: restores saved consent, opens/closes the
 * panel, and persists the user's choices to localStorage. Essential
 * cookies are always on; analytics and marketing are opt-in.
 *
 * All localStorage access is wrapped so that private-mode / disabled
 * storage never throws and breaks the page. Vanilla ES2017+, no deps.
 */
(function initCookiePanel() {
  'use strict';

  const STORAGE_KEY = 'reminiscens_cookies';

  const panel    = document.getElementById('cookiePanel');
  const openBtns = document.querySelectorAll('.footer-legal-btn, [data-cookie-open]');
  if (!panel) return;

  const analytics = document.getElementById('cookieAnalytics');
  const marketing = document.getElementById('cookieMarketing');

  // Restore previously saved preferences into the checkboxes.
  const saved = readPrefs();
  if (analytics) analytics.checked = saved.analytics === true;
  if (marketing) marketing.checked = saved.marketing === true;

  /** Show the panel and expose it to assistive technology. */
  function open() {
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
  }

  /** Hide the panel and hide it from assistive technology. */
  function close() {
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
  }

  /**
   * Read saved preferences from localStorage.
   * @returns {object} Parsed preferences, or an empty object on any failure.
   */
  function readPrefs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (err) {
      return {};
    }
  }

  /**
   * Persist preferences to localStorage, ignoring storage failures.
   * @param {object} prefs - Consent preferences to store.
   */
  function persist(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (err) {
      // Storage may be unavailable (private mode / quota); fail silently.
    }
  }

  openBtns.forEach((btn) => btn.addEventListener('click', open));

  const saveBtn   = document.getElementById('cookieSave');
  const acceptBtn = document.getElementById('cookieAcceptAll');

  if (saveBtn) {
    saveBtn.addEventListener('click', () => {
      persist({
        essential: true,
        analytics: analytics ? analytics.checked : false,
        marketing: marketing ? marketing.checked : false
      });
      close();
    });
  }

  if (acceptBtn) {
    acceptBtn.addEventListener('click', () => {
      if (analytics) analytics.checked = true;
      if (marketing) marketing.checked = true;
      persist({ essential: true, analytics: true, marketing: true });
      close();
    });
  }
})();
